import * as classNames from "classnames";
import dayjs from "dayjs";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Button } from "@components/student/Button";
import { LessonType, SkillLevel, levelRepresentation, typeRepresentation, } from "@constants";
import ArrowToBottom from "@svg/arrowToBottom.svg";
import ArrowToTop from "@svg/arrowToTop.svg";
import { ConflictModal } from "../ConflictModal";
import { LevelNotification } from "../LevelNotification";
import * as s from "./ScheduleCard.sss";
import { getTimeCorrected } from "@/utils/common";
export const ScheduleCard = ({ className, lessonSchedule, calendarView = false, isChosen = false, lessonPurchase, onButtonClick, addChange, setAddChange, createFreezeModal, individual, changed = false, existingLessons, checkout, dateOfWeek, }) => {
    var _a;
    const { t } = useTranslation();
    addChange;
    setAddChange;
    addChange;
    setAddChange;
    changed;
    const [isShowAddition, setShowAddition] = React.useState(false);
    const [trialButton, setTrialButton] = React.useState(false);
    const [levelNotification, setLevelNotification] = React.useState(false);
    const [createConflictModal, setCreateConflictModal] = React.useState(false);
    const { hall, skillLevel, coach, time, type, days, weekday } = lessonSchedule;
    const query = new URLSearchParams(location.search);
    const isFlexible = query.get("isFlexible") === "true";
    const timeCorrect = getTimeCorrected(time);
    const lessonDate = dayjs(dateOfWeek).format("DD MMMM");
    const locationName = hall.locations.map(loc => loc.name);
    const dateOfWeekDayjs = dayjs(dateOfWeek);
    const now = dayjs();
    const isToday = dateOfWeekDayjs.isSame(dayjs(), 'day');
    const isPassed = now.isAfter(dateOfWeekDayjs, 'minute');
    const isBeforeToday = dateOfWeekDayjs.isBefore(dayjs(), 'day');
    const isDisabled = (isToday && isPassed) || isBeforeToday;
    const colors = levelRepresentation[skillLevel.id] === "MIDDLE"
        ? "#F6C972"
        : levelRepresentation[skillLevel.id] === "HIGH"
            ? "#F67280"
            : levelRepresentation[skillLevel.id] === "START"
                ? "#6EE1A9"
                : levelRepresentation[skillLevel.id] === "START+"
                    ? "#f8b195"
                    : "";
    const checkScheduleConflict = () => {
        return existingLessons === null || existingLessons === void 0 ? void 0 : existingLessons.some(existingLesson => {
            return (existingLesson.weekday === lessonSchedule.weekday &&
                existingLesson.time === time);
        });
    };
    const addSchedule = () => {
        if (checkScheduleConflict()) {
            setCreateConflictModal(true);
            return;
        }
        onButtonClick && onButtonClick("add");
        setAddChange(true);
        setTrialButton(true);
        const level = levelRepresentation[skillLevel.id];
        const lesson = typeRepresentation[type.id]
            .split(" ")
            .join("");
        const levelNotificationLocal = sessionStorage.getItem("levelNotification") === "false";
        if (!levelNotificationLocal) {
            if (lesson !== typeRepresentation[LessonType.Pointe] &&
                (level === levelRepresentation[SkillLevel.Middle] ||
                    level === levelRepresentation[SkillLevel.High])) {
                setLevelNotification(true);
            }
        }
    };
    const cancelAddition = () => {
        onButtonClick && onButtonClick("cancel");
        setTrialButton(false);
    };
    const handleButtonClick = event => {
        if (!individual && !checkout) {
            const target = event.target;
            if (target.id === "buttonAdd") {
                addSchedule();
            }
            else if (target.id === "buttonCancel") {
                cancelAddition();
            }
            else if (target.id === "buttonAddTrial") {
                return;
            }
            setShowAddition(!isShowAddition);
        }
    };
    React.useEffect(() => {
        !addChange ? setTrialButton(false) : null;
    }, [addChange]);
    return (React.createElement("div", { className: classNames(s.root, className) },
        React.createElement(ConflictModal, { isOpen: createConflictModal, onClose: () => setCreateConflictModal(false) }),
        React.createElement("div", { className: classNames(s.groupInfo, { [s.calendarView]: calendarView }, { [s.isChosen]: isChosen }, { [s.isShowButtons]: isShowAddition }), id: "scheduleCard", style: {
                borderLeftColor: isChosen
                    ? "#7A4694"
                    : ((_a = hall.locations[0]) === null || _a === void 0 ? void 0 : _a.color) || "#fff",
            }, onClick: handleButtonClick },
            React.createElement("div", { className: s.scheduleInfo },
                React.createElement("div", { className: classNames(s.infoItem, { [s.hideInfo]: calendarView }) },
                    React.createElement("span", { className: s.infoProp },
                        t("student~Адрес"),
                        ":",
                        t("student~ул."),
                        " ",
                        hall.street)),
                ((lessonPurchase === null || lessonPurchase === void 0 ? void 0 : lessonPurchase.lessonSubscription.isFlexible) || isFlexible) && (React.createElement("div", { className: classNames(s.infoItem, s.capitalize) }, lessonDate)),
                React.createElement("div", { className: classNames(s.infoItem, { [s.timeInfo]: calendarView }) },
                    React.createElement("span", { className: classNames(s.infoProp) },
                        t("student~Время"),
                        ":",
                        " "),
                    timeCorrect),
                React.createElement("div", { className: classNames({ [s.infoItem]: calendarView }) },
                    React.createElement("div", { className: s.location },
                        React.createElement("span", { className: s.infoProp },
                            t("student~Метро"),
                            ": "),
                        locationName.join(", "))),
                React.createElement("div", { className: classNames(s.infoItem, { [s.levelInfo]: calendarView }) }, type.id !== 3 && (React.createElement(React.Fragment, null,
                    React.createElement("span", { className: classNames(s.infoProp, {
                            [s.hideInfo]: calendarView,
                        }) },
                        t("student~Уровень"),
                        ":",
                        " "),
                    React.createElement("span", { style: {
                            color: colors,
                        } }, levelRepresentation[skillLevel.id])))),
                React.createElement("div", { className: classNames(s.infoItem, { [s.typeInfo]: calendarView }) },
                    React.createElement("span", { className: classNames(s.infoProp, { [s.info]: calendarView }) },
                        t("student~Направление"),
                        ":",
                        " "),
                    typeRepresentation[type.id]),
                coach && (React.createElement("div", { className: classNames(s.infoItem, { [s.typeInfo]: calendarView }) },
                    React.createElement("div", { className: classNames({ [s.hideInfo]: calendarView }) },
                        React.createElement("span", { className: s.infoProp },
                            t("student~Педагог"),
                            ": "),
                        coach.firstName,
                        " ",
                        coach.lastName)))),
            !checkout && (React.createElement("div", { className: s.buttons },
                createFreezeModal && lessonPurchase && (React.createElement("div", { className: s.button },
                    React.createElement(Button, { className: s.ghostButton, disabled: Boolean(!(lessonPurchase === null || lessonPurchase === void 0 ? void 0 : lessonPurchase.freezeLeft)), onClick: () => createFreezeModal({
                            isOpen: true,
                            lessonPurchaseId: lessonPurchase.id,
                            freezeCount: lessonPurchase.freezeLeft,
                            lessonsCount: lessonPurchase.lessonSubscription.lessonsCount,
                            isFlexible: lessonPurchase.lessonSubscription.isFlexible,
                        }) }, t("student~Заморозить")))),
                !createFreezeModal && calendarView && !isChosen && (React.createElement("div", { className: s.button }, trialButton ? (React.createElement(Button, { id: "buttonAddTrial", className: classNames(s.ghostButton, s.cancel), onClick: cancelAddition }, t("student~Отменить добавление"))) : (React.createElement(Button, { id: "buttonAddTrial", className: s.ghostButton, onClick: addSchedule, disabled: isDisabled }, t("student~Записаться на занятие"))))),
                React.createElement("div", { className: s.showAdditionButton },
                    React.createElement(Button, { theme: "clean", disabled: !onButtonClick, className: s.showAddition, onClick: handleButtonClick, type: "button" }, isShowAddition ? (React.createElement(ArrowToTop, { className: s.arrow })) : (onButtonClick && React.createElement(ArrowToBottom, { className: s.arrow }))))))),
        levelNotification ? (React.createElement(LevelNotification, { isOpen: levelNotification, agreeLevel: following => {
                setLevelNotification(false);
                following && sessionStorage.setItem("levelNotification", "false");
            }, cancelAddition: cancelAddition })) : null));
};
